/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import LayoutOperation from "../../components/layout_operation";
import { Tabs } from "antd";
import {
  // UserOutlined,
  // LockOutlined,
  // BellOutlined,
  FolderOpenOutlined,
  FormOutlined,
} from "@ant-design/icons";
// import GeneralInfo from "../../ui/setting/general_information";
// import ChangePass from "../../ui/setting/change_password";
// import Notification from "../../ui/setting/notification";
import Employee from "../../ui/setting/data/employee";
//import TeamGroup from "../../ui/setting/data/teamgroup";
import TeamGroup from "../../ui/setting/data/team_group";
import TeamSub from "../../ui/setting/data/team_sub";
import Supplier from "../../ui/setting/data/supplier";
import Brand from "../../ui/setting/data/brand";
// import JobStatus from "../../ui/setting/data/job_status";
import MAperiod from "../../ui/setting/data/ma_period";
import JobSkill from "../../ui/setting/data/job_skill";
import JobCategory from "../../ui/setting/data/job_category";
import FixProblemType from "../../ui/setting/data/fix_problem_type";
import FixServiceType from "../../ui/setting/data/fix_service_type";
import FixServiceCause from "../../ui/setting/data/fix_service_cause";
import SLOCPlant from "../../ui/setting/data/sloc_plant";
import SLOCPlantSloc from "../../ui/setting/data/sloc_plantSloc";
import TeamPlantSLOC from "../../ui/setting/data/sloc_teamPlantSLOC";

import VendorGroup from "../../ui/setting/data/vendor_vendorGroup";
import VendorServiceCode from "../../ui/setting/data/vendor_serviceCode";


// import JobStepProgress from "../../ui/setting/data/job_step_progress";
import JobType from "../../ui/setting/data/job_type";
import Division from "../../ui/setting/data/division";


import Dynamic from "../../ui/setting/dynamic_list";
import Configuration from "../../ui/setting/configuration_translate";
import Checklist from "../../ui/setting/checklist";
// import ServiceCheckList from "../../ui/setting/data/service_check_list";
import ServiceType from "../../ui/setting/data/serviceType";
import { Ui } from "../../services";
import Cookies from "js-cookie";
import Api from "../../services/ServiceApi";
import "./styles/styles.css";
const { TabPane } = Tabs;

class Setting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      title: "Setting",
      menu: [
        { title: "Job Category" },
        { title: "Job Skill" },
        { title: "Job Type / Job Sub Type" },
        { title: "MA Period" },
        { title: "Department" },
        { title: "Division" },
        // { title: "Employee Shift" },
        { title: "Employee" },
        { title: "Team Group" },
        { title: "Supplier" },
        { title: "Brand Screens" },
        { title: "Service Type MA" },
        //{ title: "Job Status" },
        //{ title: "Job Step Status" },
      ],
      display: "none",
      active: 0,
      companyid: Cookies.get("companyid"),
      displayFixProblem: "none",
      displaySLOC: "none",
      displayVendorManagement: "none",
      displayTeamSubManagement: "none"
    };
  }

  componentDidMount() {
    document.title = "Setting";
  }

  onSelectTab(key) {
    if (key === 4) {
      this.setState({ display: "block" });
    } else {
      this.setState({ display: "none" });
    }
  }

  onSelectMenu(index) {
    this.setState({ active: index });
    if((index === 7) && !(this.state.companyid === 1)) this.setState({displayTeamSubManagement: "block"});
  }

  render() {
    if (parseInt(this.state.companyid ) === 1) {
      return this.renderPlanB();
    } else {
      return this.renderUIH();
    }
  }

  toggleSwitchMenuFixProblem(){
    if(this.state.displayFixProblem === "none"){
      this.setState({ displayFixProblem: "block"});
    }else{
      this.setState({ displayFixProblem: "none" });
    }
  }
  toggleSwitchMenuSLOC(){
    if(this.state.displaySLOC == "none"){
      this.setState({ displaySLOC: "block"});
    }else{
      this.setState({ displaySLOC: "none" });
    }
  }
  toggleSwitchMenuVendor(){
    if(this.state.displayVendorManagement == "none"){
      this.setState({ displayVendorManagement: "block"});
    }else{
      this.setState({ displayVendorManagement: "none" });
    }
  }

  toggleSwitchMenuTeam(){
    if(this.state.displayTeamSubManagement == "none"){
      this.setState({ displayTeamSubManagement: "block"});
    }else{
      this.setState({ displayTeamSubManagement: "none" });
    }
  }

  renderPlanB() {
    const {  title, menu, display, active } = this.state;
    return (
      <LayoutOperation active={8}>
        <div className="wrapper-header d-flex align-items-center">
          <div className="container-fluid">
            <div className="d-flex align-items-center">
              <img
                src={Api.absoluteUrl("/icon/setting_white.svg")}
                className="mr-3"
              />
              <h2 className="c-white text-uppercase m-0 d-inline-block font-mont-b font20">
                {title}
              </h2>
            </div>
          </div>
        </div>

        <div className="wrapper-body">
          <div className="container-fluid">
            <div className="card-table-ma">
              <Tabs
                defaultActiveKey="1"
                tabPosition="left"
                onChange={(key) => this.onSelectTab(key)}
              >
                {/* <TabPane
                  tab={
                    <div className="d-flex">
                      <UserOutlined />
                      <div>
                        <h6>General information</h6>
                        <span
                          className="font-mont-r font10"
                          style={{ color: "#98A9BC" }}
                        >
                          Profile photo, name
                        </span>
                      </div>
                    </div>
                  }
                  key="1"
                >
                  <GeneralInfo />
                </TabPane> */}
                {/* <TabPane
                  tab={
                    <div className="d-flex">
                      <LockOutlined />
                      <div>
                        <h6>Security</h6>
                        <span
                          className="font-mont-r font10"
                          style={{ color: "#98A9BC" }}
                        >
                          Password
                        </span>
                      </div>
                    </div>
                  }
                  key="2"
                >
                  <ChangePass />
                </TabPane> */}
                {/* <TabPane
                  tab={
                    <div className="d-flex">
                      <BellOutlined />
                      <div>
                        <h6 style={{textAlign: "left"}}>Notifications</h6>
                        <span
                          className="font-mont-r font10"
                          style={{ color: "#98A9BC" }}
                        >
                          Set your notifications
                        </span>
                      </div>
                    </div>
                  }
                  key="3"
                >
                  <Notification />
                </TabPane> */}
                <TabPane
                  tab={
                    <div>
                      <div className="d-flex">
                        <FolderOpenOutlined />
                        <div>
                          <h6>Basic Data</h6>
                          <span
                            className="font-mont-r font10"
                            style={{ color: "#98A9BC" }}
                          >
                            Setting Data
                          </span>
                        </div>
                      </div>
                      <ul
                        className="menu-basic-data"
                        style={{ display: display }}
                      >
                        {menu.map((item, index) => (
                          <li
                            key={index}
                            className={active == index ? "active" : ""}
                          >
                            <a onClick={() => this.onSelectMenu(index)}>
                              {item.title}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  }
                  key="4"
                >
                  {active === 0 ? <JobCategory /> : null}
                  {active === 1 ? <JobSkill /> : null}
                  {active === 2 ? <JobType /> : null}
                  {active === 3 ? <MAperiod /> : null}
                  {active === 4 ? <Ui.Department /> : null}
                  {active === 5 ? <Division /> : null}
                  {/* {active === 6 ? <Ui.EmployeeShift /> : null} */}
                  {active === 6 ? <Employee /> : null}
                  {active === 7 ? <TeamGroup /> : null}
                  {active === 8 ? <Supplier /> : null}
                  {active === 9 ? <Brand /> : null}
                  {active === 10 ? <ServiceType /> : null}
                  {/* {active === 3 ? <JobStatus /> : null}
                  {active === 4 ? <JobStepProgress /> : null} */}
                </TabPane>
                {/* <TabPane
                  tab={
                    <div className="d-flex">
                      <FormOutlined />
                      <div>
                        <h6 style={{textAlign: "left"}}>Dynamic</h6>
                        <span
                          className="font-mont-r font10"
                          style={{ color: "#98A9BC" }}
                        >
                          Set your dynamic forms
                        </span>
                      </div>
                    </div>
                  }
                  key="5"
                >
                  <Dynamic />
                </TabPane> */}
                <TabPane
                  tab={
                    <div className="d-flex">
                      <FormOutlined />
                      <div>
                        <h6 style={{ textAlign: "left" }}>Configuration</h6>
                        <span
                          className="font-mont-r font10"
                          style={{ color: "#98A9BC" }}
                        >
                          Set your configuration translate
                        </span>
                      </div>
                    </div>
                  }
                  key="6"
                >
                  <Configuration key="con_12m3x" />
                </TabPane>
                <TabPane
                  tab={
                    <div className="d-flex">
                      <FormOutlined />
                      <div>
                        <h6 style={{ textAlign: "left" }}>Check List</h6>
                        <span
                          className="font-mont-r font10"
                          style={{ color: "#98A9BC" }}
                        >
                          Set your Check List
                        </span>
                      </div>
                    </div>
                  }
                  key="7"
                >
                  <Checklist />
                </TabPane>
              </Tabs>
            </div>
          </div>
        </div>
      </LayoutOperation>
    );
  }

  renderUIH() {
    const { loading, title, menu, display, active } = this.state;
    return (

      <LayoutOperation active={7}>
        <div className="wrapper-header d-flex align-items-center">
          <div className="container-fluid">
            <div className="d-flex align-items-center">
              <img
                src={Api.absoluteUrl("/icon/setting_white.svg")}
                className="mr-3"
              />
              {/*  <img src="/icon/setting_white.svg" className="mr-3" /> */}
              <h2 className="c-white text-uppercase m-0 d-inline-block font-mont-b font20">
                {title}
              </h2>
            </div>
          </div>
        </div>

        <div className="wrapper-body">
          <div className="container-fluid">
            <div className="card-table-ma">
              <Tabs
                defaultActiveKey="1"
                tabPosition="left"
                onChange={(key) => this.onSelectTab(key)}
              >
                {/* <TabPane
                  tab={
                    <div className="d-flex">
                      <UserOutlined />
                      <div>
                        <h6>General information</h6>
                        <span
                          className="font-mont-r font10"
                          style={{ color: "#98A9BC" }}
                        >
                          Profile photo, name
                        </span>
                      </div>
                    </div>
                  }
                  key="1"
                >
                  <GeneralInfo />
                </TabPane> */}
                {/* <TabPane
                  tab={
                    <div className="d-flex">
                      <LockOutlined />
                      <div>
                        <h6>Security</h6>
                        <span
                          className="font-mont-r font10"
                          style={{ color: "#98A9BC" }}
                        >
                          Password
                        </span>
                      </div>
                    </div>
                  }
                  key="2"
                >
                  <ChangePass />
                </TabPane> */}
                {/* <TabPane
                  tab={
                    <div className="d-flex">
                      <BellOutlined />
                      <div>
                        <h6 style={{textAlign: "left"}}>Notifications</h6>
                        <span
                          className="font-mont-r font10"
                          style={{ color: "#98A9BC" }}
                        >
                          Set your notifications
                        </span>
                      </div>
                    </div>
                  }
                  key="3"
                >
                  <Notification />
                </TabPane> */}
                <TabPane
                  tab={
                    <div>
                      <div className="d-flex">
                        <FolderOpenOutlined />
                        <div>
                          <h6>Basic Data</h6>
                          <span
                            className="font-mont-r font10"
                            style={{ color: "#98A9BC" }}
                          >
                            Setting Data
                          </span>
                        </div>
                      </div>
                      <ul
                        className="menu-basic-data"
                        // style={{ display: display }}
                      >
                        {menu.map((item, index) => (
                          <li
                            key={index}
                            className={active == index ? "active" : ""}
                          >
                            <a onClick={() => this.onSelectMenu(index)}>
                              {item.title}
                            </a>
                            {(index == 7)? 
                            <div style={{ display: this.state.displayTeamSubManagement, textIndent:"30px" }} className={active == 107 ? "active-submenu" : "none-active"}><a onClick={() => this.onSelectMenu(107)}>Team Sub</a></div>
                          :null}
                          </li>

                        ))}
                        <li>
                            <a onClick={() => this.toggleSwitchMenuFixProblem()}>
                              Fix Problem
                            </a>
                            <ul id="menuFixProblem" style={{ display: this.state.displayFixProblem }} className="menu-basic-data-sub">
                              <li className={active == 99 ? "active" : ""}><a onClick={() => this.onSelectMenu(99)}>Problem Type</a></li>
                              <li className={active == 100 ? "active" : ""}><a onClick={() => this.onSelectMenu(100)}>Service Type</a></li>
                              <li className={active == 101 ? "active" : ""}><a onClick={() => this.onSelectMenu(101)}>Service Cause</a></li>
                            </ul>
                          </li>

                          <li>
                            <a onClick={() => this.toggleSwitchMenuSLOC()}>
                              SLOC
                            </a>
                            <ul id="menuSLOC" style={{ display: this.state.displaySLOC }} className="menu-basic-data-sub">
                              <li className={active == 102 ? "active" : ""}><a onClick={() => this.onSelectMenu(102)}>Plant</a></li>
                              <li className={active == 103 ? "active" : ""}><a onClick={() => this.onSelectMenu(103)}>Team Plant SLOC</a></li>
                              <li className={active == 104 ? "active" : ""}><a onClick={() => this.onSelectMenu(104)}>Plant SLOC</a></li>
                            </ul>
                          </li>

                          <li>
                            <a onClick={() => this.toggleSwitchMenuVendor()}>
                              Vendor Management
                            </a>
                            <ul id="menuVendorManagement" style={{ display: this.state.displayVendorManagement }} className="menu-basic-data-sub">
                              <li className={active == 105 ? "active" : ""}><a onClick={() => this.onSelectMenu(105)}>Vendor Group</a></li>
                              <li className={active == 106 ? "active" : ""}><a onClick={() => this.onSelectMenu(106)}>Service Code</a></li>

                            </ul>
                          </li>
                      </ul>
                    </div>
                  }
                  key="4"
                >
                  {active === 0 ? <JobCategory /> : null}
                  {active === 1 ? <JobSkill /> : null}
                  {active === 2 ? <JobType /> : null}
                  {active === 3 ? <MAperiod /> : null}
                  {active === 4 ? <Ui.Department /> : null}
                  {active === 5 ? <Division /> : null}
                  {active === 6 ? <Employee /> : null}
                  {active === 7 ? <TeamGroup />: null}
                  {active === 8 ? <Supplier /> : null}
                  {active === 9 ? <Brand /> : null}
                  {active === 10 ? <ServiceType /> : null}

                  {/*active === 6 ? <Ui.EmployeeShift /> : null
                  //active === 7 ? <Employee /> : null
                  //active === 8 ? <TeamGroup /> : null
                  //active === 9 ? <Supplier /> : null
                  //active === 10 ? <Brand /> : null*/}

                  {active === 99 ? <FixProblemType /> : null}
                  {active === 100 ? <FixServiceType /> : null}
                  {active === 101 ? <FixServiceCause /> : null}
                  {active === 102 ? <SLOCPlant /> : null}
                  {active === 103 ? <TeamPlantSLOC /> : null}
                  {active === 104 ? <SLOCPlantSloc /> : null}
                  {active === 105 ? <VendorGroup /> : null}
                  {active === 106 ? <VendorServiceCode /> : null}
                  {active === 107 ? <TeamSub /> : null}


                  {/*active === 3 ? <JobStatus /> : null}
                  {active === 4 ? <JobStepProgress /> : null*/}

                </TabPane>
                <TabPane
                  tab={
                    <div className="d-flex">
                      <FormOutlined />
                      <div>
                        <h6 style={{ textAlign: "left" }}>Dynamic</h6>
                        <span
                          className="font-mont-r font10"
                          style={{ color: "#98A9BC" }}
                        >
                          Set your dynamic forms
                        </span>
                      </div>
                    </div>
                  }
                  key="5"
                >
                  <Dynamic />
                </TabPane>
                <TabPane
                  tab={
                    <div className="d-flex">
                      <FormOutlined />
                      <div>
                        <h6 style={{ textAlign: "left" }}>Configuration</h6>
                        <span
                          className="font-mont-r font10"
                          style={{ color: "#98A9BC" }}
                        >
                          Set your configuration translate
                        </span>
                      </div>
                    </div>
                  }
                  key="6"
                >
                  <Configuration key="con_12m3x" />
                </TabPane>

                <TabPane
                  tab={
                    <div className="d-flex">
                      <FormOutlined />
                      <div>
                        <h6 style={{ textAlign: "left" }}>Check List</h6>
                        <span
                          className="font-mont-r font10"
                          style={{ color: "#98A9BC" }}
                        >
                          Set your Check List
                        </span>
                      </div>
                    </div>
                  }
                  key="7"
                >
                  <Checklist />
                </TabPane>
              </Tabs>
            </div>
          </div>
        </div>
      </LayoutOperation>
    );
  }
}

export default Setting;
